import * as uiActions from './ui/actions'
import * as backendActions from './backend/actions'
import * as localizedActions from './localized/actions'
import * as serversActions from './servers/actions'
import * as displayActions from './display/actions'
import { constants } from './constants'

// eslint-disable-next-line
export const actions = {
    display: displayActions,
    backend: backendActions,
    localized: localizedActions,
    ui: uiActions,
    servers: serversActions,
    forgetAllPinnedUsers: () => ({
        type: constants.FORGET_ALL,
    }),
    uiSettingsChanged: newUiSettings => ({
        type: constants.UI_SETTINGS_CHANGED,
        payload: newUiSettings,
    }),
    settingsChanged: newSettings => ({
        type: constants.BACKEND_SETTINGS_CHANGED,
        payload: newSettings,
    }),
    languageChanged: (prevLocale, newLocale) => ({
        type: constants.LANGUAGE_CHANGED,
        payload: { prevLocale, newLocale },
    }),
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/actions.js